import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Layout } from '../components';
import {
    Dashboard,
    Matching,
    Categories,
    Offsets,
    Error404,
    Sectors,
} from '../domains';
import { ContributionsRoutes, UserRoutes } from './';
import { useUser } from '../context';
import Can from '../utils/rules/Can';
import ProjectRoutes from './ProjectRoutes';

const AuthenticatedRoutes = () => {
    const { user } = useUser();

    return (
        <Layout>
            <Can
                condition={user && user.role}
                perform="routes:shop"
                yes={() => (
                    <Switch>
                        <Route exact path="/" component={Dashboard} />
                        <Route exact path="/sectors" component={Sectors} />
                        <Route path="/projects" component={ProjectRoutes} />
                        <Route
                            exact
                            path="/categories"
                            component={Categories}
                        />
                        <Route exact path="/products" component={Matching} />
                        <Route exact path="/offsets" component={Offsets} />
                        <Route
                            path="/contributions"
                            component={ContributionsRoutes}
                        />
                        <Route path="/projects" component={ProjectRoutes} />
                        <Route path="/user" component={UserRoutes} />
                        <Route component={Error404} />
                    </Switch>
                )}
            />
        </Layout>
    );
};

export default AuthenticatedRoutes;
